export const SDPHeaderTexts = {
  header: 'Sorted by what’s relevant to you',
  subHeader: {
    recipeOnlyPreferences: 'Based on your preferences',
    dietaryOnlyPreferences: 'Based on your dietary preferences',
    dietaryAndRecipePreferences: 'Based on your preferences and dietary preferences',
  },
}
